import { Button, Col, Form, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import {
    updateSurveyThresholdCustomNSize,
} from '../../actions/survey.action';
import { openModal } from '../../actions/modal.action';

import { useDispatch, useSelector } from 'react-redux';

const EditThresholdModal = ({
    showEditThreshold,
    handleToggleEditThreshold,
    minRespondents,
    id
}) => {
    const dispatch = useDispatch();
    const [invalid, setInvalid] = useState(false);
    const [threshold, setThreshold] = useState(20);
    const jwt = useSelector((state) => state.session.jwt);

    const handleSaveThresholdCustomNSize = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === false) {
            setInvalid(true);
        } else {
            dispatch(updateSurveyThresholdCustomNSize(id, threshold, jwt));
        }
        handleToggleEditThreshold();
    };

    const handleThresholdChange = (e) => {
        const { value } = e.target;
        if(value !== '' && Number(value) <= 0){
            openModal({
              className: 'modal-alert-width',
              button1Text: 'Close',
              button1Action: 'closeModal',
              imageSrc: '/icons/triangle.png',
              body: 'Suppression threshold must be greater than 0',
            })(dispatch);
            setInvalid(true);
            return;
        }
        setInvalid(false);
        setThreshold(e.target.value);
    }

    const onLoading = () => {
        if(!minRespondents) return;
        setThreshold(minRespondents)
    }

    return (
        <Modal
            centered
            show={showEditThreshold}
            onShow={onLoading}
            onHide={handleToggleEditThreshold}
            backdrop="static"
        >
            <Modal.Header closeButton>
                <h3>Edit Threshold</h3>
            </Modal.Header>
            <Form
                noValidate
                validated={!invalid}
                className="text-left"
                onSubmit={handleSaveThresholdCustomNSize}
            >
                <Modal.Body>
                    <Form.Row>
                        <Form.Label>
                            By default, Bento suppresses data for any survey questions with an N-size {"<"} 20. Adjust the threshold for suppression by entering a new threshold below. Bento will suppress data in this survey for any questions with an N-size smaller than the number you enter. The threshold must be greater than 0.
                        </Form.Label>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="6" controlId="validationThreshold">
                            <Form.Label>Threshold *</Form.Label>
                            <Form.Control
                                defaultValue={threshold}
                                placeholder="Threshold custom N-Size"
                                required
                                onChange={handleThresholdChange}
                            />
                            <Form.Control.Feedback type="invalid">
                                Please complete Threshold.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" size="xl" onClick={handleToggleEditThreshold}>
                        CANCEL
                    </Button>
                    <Button disabled={invalid} type="submit" variant="dark" size="xl">
                        SAVE
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    )
}

export default EditThresholdModal;
